import React from "react";
import { RefreshCw } from "lucide-react";
import { PawktLogo } from "@/components/pawkt/PawktLogo";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error("Pawkt app error:", error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div
          className="flex h-screen w-full flex-col items-center justify-center gap-5 bg-white px-6 text-center"
          data-testid="app-error-state"
        >
          <PawktLogo variant="splash" />
          <div>
            <p className="font-display text-xl font-bold text-pawkt-text">Something went wrong</p>
            <p className="mt-1 max-w-sm text-sm text-pawkt-text-secondary">
              An unexpected error occurred. Reloading usually fixes it.
            </p>
          </div>
          <button
            onClick={() => window.location.reload()}
            data-testid="app-error-reload-btn"
            className="inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-white shadow-purpleGlow transition-colors hover:bg-pawkt-primary-hover"
          >
            <RefreshCw className="h-4 w-4" /> Reload Pawkt
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
